function colorSelectorModule() {
    this.init = function () {
        $(".js-select-color").on("click", function (e) {
            e.preventDefault();

            var $color = $(this);
            var $container = $color.parents(".color-selector");
            var color_name = $color.find(".js-color-name").html();
            var image_source = $color.attr("data-image");

            $container.addClass("color-selected");

            $container.find(".js-selected-color-name").html(color_name);
            $container
                .parent()
                .find(".color-selector-target")
                .attr("src", image_source);
        });
    };
}

module.exports = colorSelectorModule;
